
import './EditProfileIconButton.scss';
export default function EditProfileIconButton(props: {
    onClick: () => void,
    profileImage: string
}) {
    return (
        <div aria-label="Profile icon is currently set to Mandalorian. Select this to choose a different profile icon." onClick={() => {
            props.onClick();
        }} data-testid="Mandalorian"
            role="button" tabIndex={0} className="sc-kLIISr sc-iGPElx fEHnoF thisone">
            <div className="sc-dliRfk sc-jXQZqI dSrGjP profile-avatar" style={{
                background: `url(${props.profileImage})  0% 0% / contain no-repeat`
            }}>
                <img aria-label="" name="edit" src="https://static-assets.bamgrid.com/product/disneyplus/images/edit.0a8445c2cff0e80361b2e66906aaeca0.svg" className="sc-etwtAo eTfMgc" />
            </div>
        </div>
    );
}